/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".overview[_ngcontent-%COMP%]{padding:30px}i.fa[_ngcontent-%COMP%]{margin-left:5px}"];
export { styles as styles };
